import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const relativeFromNow = (d: Date | string | undefined): string => {
  if (!d) return "";
  const m = dayjs(d as string);
  if (!m.isValid()) return "";
  return m.fromNow();
};

export const absoluteTime = (d: Date | string | undefined): string => {
  if (!d) return "";
  const m = dayjs(d as string);
  if (!m.isValid()) return "";
  return m.format("YYYY-MM-DD HH:mm");
};
